import { Link } from 'react-router-dom';

import { ChevronRight, GripVertical, Pencil, Plus } from 'lucide-react';
import { DefaultTooltip, cn, Label, ButtonIcon } from 'twyne-new.ui';

import { removeScaleY } from '@/components/SortableDnd';

import ProfileProgressMetrics from './ProfileProgressMetrics';
import ProgressContainer from './paths/ProgressContainer';

const DragIcon = ({ isDefault, dnd }) => <div {...dnd?.dragProps}>
  <DefaultTooltip content={isDefault && 'You cannot change the default profile sequence'}>
    <GripVertical size='18' className='cursor-grab' />
  </DefaultTooltip>
</div>

export default function SortableItem({ item, options, onToggleManage, index, isCollapse, onChangeCollapse, pendingSave, getLabel, dnd = {} }) {
  const active = item.value === null || item.active === undefined ? true : item.active
  const isDefault = item.key === null
  const style = removeScaleY(dnd?.style)

  if (isDefault) item.name = "Default"

  return <li data-id={item.key} ref={dnd?.setNodeRef} style={style}>
    <div className={cn('flex gap-2 p-2 border twy-border-base rounded items-center', !active && 'opacity-50')}>
      <DragIcon key={item.key} isDefault={isDefault} dnd={dnd} />
      <div className='flex flex-col gap-2 w-full min-w-0'>
        <div className='flex justify-between items-center max-md:flex-wrap max-md:gap-x-2 max-md:gap-y-1'>
          <Title
            isCollapse={isCollapse}
            onChangeCollapse={() => onChangeCollapse(item.key)}
            item={item}
          />
          <div className="flex items-center gap-2 max-md:contents">
            <Actions
              name={item.name}
              id={item && item.key}
              onToggleManage={() => onToggleManage(index)}
              isDefault={isDefault}
              pendingSave={pendingSave}
            />
            <div className='md:contents max-md:flex max-md:basis-full max-md:justify-end max-md:empty:hidden'>
              <ProfileProgressMetrics item={item} />
            </div>
          </div>
        </div>
        <ProgressContainer
          paths={item.value}
          options={options}
          onToggleManage={onToggleManage}
          profileIndex={index}
          isCollapse={isCollapse}
          getLabel={getLabel}
        />
      </div>
    </div>
  </li>
}

const Title = ({ isCollapse, onChangeCollapse, item }) => <div className='flex gap-1 items-center min-w-0 max-md:flex-1'>
  <ChevronRight size='18' className={cn(!isCollapse && 'rotate-90', 'hover:twy-text-base-accent cursor-pointer')} onClick={onChangeCollapse} />
  <Label className='twy-text-base-accent text-[0.8rem] mr-1 max-md:truncate'>{item.name}</Label>
</div>

const Actions = ({ isDefault, pendingSave, id, onToggleManage }) => <div className="flex items-center gap-2 border-r twy-border-base pr-2 max-md:border-r-0 max-md:pr-0">
  {!isDefault ? <>
    <Link to={!pendingSave && `/path/dashboard/user_profile/${id}`}>
      <ButtonIcon content={pendingSave ? 'Save user profiles before editing them' : 'Edit User Profile'} disabled={pendingSave}>
        <Pencil size='14' className='hover:twy-text-base-accent cursor-pointer' />
      </ButtonIcon>
    </Link>
  </> : null}
  <ButtonIcon content='Add path' onClick={onToggleManage} id={`add-profile-${id}`}>
    <Plus size='18' />
  </ButtonIcon>
</div>

